import { Component, OnInit } from '@angular/core';
import { DescricaoSistemaService } from '../../servicos/descricao-sistema.service';
import { PRINCIPAL } from 'src/app/global/navegacao';
import { SegurancaService } from 'src/app/frameworks/seguranca/servicos/seguranca.service';
import { AcessoQRY, RespostaServidorVO } from '../../tiposPrevimil';
import { GerenciadorAcessosService } from 'src/app/frameworks/seguranca/servicos/gerenciador-acessos.service';

@Component({
    selector: 'prv-dashboard-usuario',
    templateUrl: './dashboard-usuario.component.html',
    styleUrls: ['./dashboard-usuario.component.scss'],
    standalone: false
})
export class DashboardUsuarioComponent implements OnInit {

  /*
    {nome:"Telemarketing",icone:PREVIMIL_ICONE.TELEMARKETING.GRANDE,caminho:"/telemarketing/principal"},
    {nome:"Produção",icone:PREVIMIL_ICONE.PRODUCAO.GRANDE,caminho:"/producao/principal"},

    {nome:"Gestão Interna",icone:PREVIMIL_ICONE.GESTAO_INTENA.GRANDE,caminho:"/gestaoInterna/principal"},
    {nome:"Configuracoes",icone:PREVIMIL_ICONE.CONFIGURACOES.GRANDE,caminho:"/gestaoInterna/financeiro"},
    */

  /* public modulosUsuario = PRINCIPAL.rotas; */
  public modulosUsuario:any[] = [];

  escopos: Set<string> = new Set<string>();

  constructor(
    public descricaoModulo:DescricaoSistemaService,
    private segurancaService:SegurancaService,
    private gerenciadorAcessosService: GerenciadorAcessosService) { }

  ngOnInit() {
      console.log("Carregar menu: WEB_PORTAL_DASHBOARD");
      this.segurancaService.obterAcessosUsuario(this.descricaoModulo.getIdModulo()).subscribe(
          resposta => {
            this.modulosUsuario = (resposta as RespostaServidorVO<AcessoQRY[]>).sucesso;
            console.log("Carregar menu: WEB_PORTAL_DASHBOARD - SUCESSO");
          },
          falha => {
            console.log(falha);
          }
      );

      this.escopos = new Set<string>();
      this.gerenciadorAcessosService.obterEscopos().forEach(e => this.escopos.add(e));
      console.log(this.escopos);
  }

  temAcessoInformePagamento(){
    return true;
    //return this.escopos.has('informe.pagamento:baixar_informe_anual');
  }

} /*
ngOnInit() {
  console.log("Carregar menu: WEB_PORTAL_DASHBOARD");
  this.segurancaService.obterAcessosUsuario(this.descricaoModulo.getIdModulo()).subscribe(
    resposta => {
      const modulosOriginais = (resposta as RespostaServidorVO<AcessoQRY[]>).sucesso;
      
      // --- A TRADUÇÃO ACONTECE AQUI ---
      // Usamos .map() para criar um NOVO array com os nomes dos ícones traduzidos
      this.modulosUsuario = modulosOriginais.map(modulo => {
        // O 'modulo.icone' tem o nome da classe antiga (ex: 'icone_comercial_performance')
        // A função 'traduzirIcone' retorna o nome do ícone do Google (ex: 'trending_up')
        const nomeIconeNovo = this.traduzirIcone(modulo.icone);
        
        // Retornamos um novo objeto...
        return {
          ...modulo, // ...com todas as propriedades antigas...
          googleIcone: nomeIconeNovo // ...e a nova propriedade com o nome do ícone do Google
        };
      });
      // ---------------------------------

      console.log("Carregar menu: WEB_PORTAL_DASHBOARD - SUCESSO", this.modulosUsuario);
    },
    falha => {
      console.log(falha);
    }
  );

  this.escopos = new Set<string>();
  this.gerenciadorAcessosService.obterEscopos().forEach(e => this.escopos.add(e));
}

temAcessoInformePagamento() {
  return this.escopos.has('informe.pagamento:baixar_informe_anual');
}

/**
 * Função "Tradutora"
 * Converte os nomes das classes de ícone antigas para os nomes dos ícones do Google Material Symbols.
 
private traduzirIcone(iconeAntigo: string): string {
  switch (iconeAntigo) {
    // Ícones do Dashboard
    case 'icone_comercial_principal': return 'storefront';
    case 'icone_comercial_performance': return 'trending_up';
    case 'icone_financeiro': return 'account_balance';
    case 'icone_seguranca': return 'security';
    case 'icone_integracao': return 'hub';
    case 'icone_operacoes': return 'settings';
    case 'icone_anuencia_eletronica': return 'draw';
    case 'icone_compliance': return 'fact_check';
    case 'icone_recebimento': return 'account_balance_wallet';
    case 'icone_planilha_cosseguro': return 'table_chart';
    case 'icone_contabilidade': return 'calculate';
    case 'icone_diversos': return 'apps';
    case 'icone_atuarial': return 'analytics';
    case 'icone_arrecadacao': return 'paid';

    // Ícones da Sidebar (exemplo)
    case 'fa fa-user-circle': return 'account_circle';
    case 'fa fa-sign-out': return 'logout';

    // Caso padrão: se não encontrar tradução, usa um ícone genérico
    default:
      return 'apps'; // 'apps' é um bom ícone genérico
  }
}
} */